import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';

import { logger } from '@luna/logger';
import type { SSEEventBus } from '@luna/api';
import { dispatchSseEvents } from '@luna/api';

import { createSseContextProvider } from './SSEContext';

interface Props {
    children: ReactNode;
    eventBus: SSEEventBus;
}

const { Provider } = createSseContextProvider({});

export const SseProvider: FC<Props> = ({ children, eventBus }) => {
    useEffect(() => {
        const abortController = new AbortController();

        dispatchSseEvents({ eventBus, signal: abortController.signal }).catch(logger.error);

        return () => {
            abortController.abort();
        };
    }, [eventBus]);

    return <Provider value={{ eventBus }}>{children}</Provider>;
};
